import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import Upload from './Upload/component';
import { IAppState } from '../../../state/reducers';
import { clearAll, selectIsUploading } from '../../../state/exchange/uploadDialog';

class UploadDialog extends PureComponent<IProps> {
  render() {
    const {
      isOpen,
      onClose,
      isUploading,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={!isUploading ? onClose : null}
        fullWidth
        maxWidth="md"
      >
        <Upload />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.uploadDialog.isOpen,
  isUploading: selectIsUploading(state),
});

const mapDispatchToProps: IDispatchProps = {
  onClose: clearAll,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadDialog);
